
























import { Vue, Component, PropSync } from 'vue-property-decorator'
import { ScreenText } from '@/lang/ScreenText'

import WarningModal from '@/popupcomponents/WarningModal.vue'
import commonEntry from '@/store/modules/commonEntry'

@Component({
  components: {
    WarningModal
  }
})
export default class LeaveAlert extends Vue {
  @PropSync('isVisible') isVisibleSync!: boolean
  commonEntry = commonEntry

  get accentColor() {
    return commonEntry.accountDesignDetails.accentColor
  }
  public readonly screenText: ScreenText = new ScreenText()
}
